import { render, staticRenderFns } from "./OrgDetail.vue?vue&type=template&id=62d960e0&"
import script from "./OrgDetail.vue?vue&type=script&lang=ts&"
export * from "./OrgDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OrgDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports